__webpack_require__.p = "https://icspt.iitp.ac.in/";